import { useEffect, useState } from 'react';

/** Design canvas size matching AI selfie station portrait kiosk. */
export const PORTRAIT_WIDTH = 800;
export const PORTRAIT_HEIGHT = 1280;

export const PORTRAIT_STAGE_ID = 'portrait-stage';
export const PORTRAIT_VIEWPORT_ID = 'portrait-viewport';

/** Mount point for full-screen backgrounds that should not be scaled. */
export const getPortraitViewportContainer = () =>
  document.getElementById(PORTRAIT_VIEWPORT_ID);

/** Mount point for portals (modals) so they scale with the stage. */
export const getPortraitStageContainer = () =>
  document.getElementById(PORTRAIT_STAGE_ID);

/**
 * Scales the 800x1280 design to fit the viewport (contain), then stretches the
 * stage along the longer axis so it always fills the full screen.
 */
function PortraitStage({ children, className = '' }) {
  const [size, setSize] = useState({
    scale: 1,
    width: PORTRAIT_WIDTH,
    height: PORTRAIT_HEIGHT,
  });

  useEffect(() => {
    const update = () => {
      const sx = window.innerWidth / PORTRAIT_WIDTH;
      const sy = window.innerHeight / PORTRAIT_HEIGHT;
      // Fit the full stage (no crop) so chrome at top/left stays on-screen
      // when kiosk height changes.
      const scale = Math.min(sx, sy);
      // Grow the stage to fill the viewport at that scale, so pages cover
      // the full screen instead of leaving bars around a fixed 800x1280 box.
      setSize({
        scale,
        width: window.innerWidth / scale,
        height: window.innerHeight / scale,
      });
    };

    update();
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }, []);

  return (
    <div
      id={PORTRAIT_VIEWPORT_ID}
      className={`portraitViewport ${className}`.trim()}
    >
      <div
        id={PORTRAIT_STAGE_ID}
        className="portraitStage"
        style={{
          width: size.width,
          height: size.height,
          transform: `scale(${size.scale})`,
        }}
      >
        {children}
      </div>
    </div>
  );
}

export default PortraitStage;
